/** Revenue streams as people read them (product_group.revenue_stream, migration 0027). */
export const STREAM_LABELS: Record<string, string> = {
  studio: 'Studio implementation',
  software: 'Foundation software',
  workstream: 'Workstream',
  consulting: 'Consulting',
  agents: 'AI agents',
  other: 'Other',
};

export interface Rollup {
  months: string[];
  streams: string[];
  cells: { stream: string; month: string; amount: number; hours: number | null }[];
  totals: { amount: number; byStream: Record<string, number> };
  /** Some of it was edited by hand on the opportunity (migration 0040). */
  edited?: boolean;
}

/** Rows for the grid: one per stream, a column per month, and a total row. */
export function rollupGrid(r: Rollup) {
  const amount = (stream: string | null, month: string | null) =>
    r.cells.filter((c) => (stream === null || c.stream === stream) && (month === null || c.month === month)).reduce((s, c) => s + c.amount, 0);
  return [
    ...r.streams.map((stream) => ({ id: stream, label: STREAM_LABELS[stream] ?? stream, byMonth: Object.fromEntries(r.months.map((m) => [m, amount(stream, m)])), total: amount(stream, null) })),
    { id: 'total', label: 'Total', byMonth: Object.fromEntries(r.months.map((m) => [m, amount(null, m)])), total: amount(null, null) },
  ];
}
